<div class="card-container card">
  <div class="card-header" style="background-color: #e7e6e6">
    <div class="card-header-title d-flex justify-content-center" style="margin-left: -4px">
      <h4 class="card-title text-uppercase" (click)="navigateTo('/central/tasks')">
        <button class="btn text-uppercase" style="background-color: white; color: black">Manage Tasks</button>

        <span
          *ngIf="notificationNavs[2]?.badgeCount > 0"
          [matBadge]="notificationNavs[2]?.badgeCount"
          style="display: absolute; margin-left: 0px; margin-top: -4 px"
        ></span>
      </h4>
      <span (click)="showTaskSummary()" style="margin-top: 10px">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </span>
    </div>
  </div>
  <div *ngIf="isShowTaskSummary">
    <div class="d-flex justify-content-center text-uppercase p-2"><label>Your Tasks Summary</label></div>

    <div class="d-flex justify-content-center flex-wrap">
      <button
        class="btn btn-secondary m-1 notification-nav bg-gradient-primary text-white text-uppercase"
        *ngFor="let nav of notificationNavs; let i = index"
        (click)="setActiveNav(i)"
      >
        <span *ngIf="nav.badgeCount > 0" [matBadge]="nav.badgeCount" style="margin-right: 10px; padding-bottom: 6px"></span>
        {{ nav.label }}
      </button>
    </div>
  </div>
</div>
